import React, {Component} from 'react';
import * as firebase from 'firebase';
import {Link} from 'react-router-dom';
import MetaTags from 'react-meta-tags';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';


export default class MailBox extends Component {
  constructor() {
    super();
    this.state = {
      blog: []
    }
    this.gotData = this.gotData.bind(this);
    this.errData = this.errData.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0,0);
    firebase.auth().onAuthStateChanged((user) => {
      if(user) {
        var userId = firebase.auth().currentUser.uid
        if( userId === '1CMe6HDAE6hZ0yzAAJvMz3yubok1' || userId === 'hZzPTCY7MNfOooscFxOAFRBjZeW2' || userId === 'P60qjlQdBMWppMrUA4l48lvLwbl1' || userId === 'Rh7ph1zzqgdnCUR7YPM9YMPpG512' ) {
          const postRef = firebase.database().ref('mailBox/')
          postRef.once('value', snap => {
            var exists = (snap.val() !== null)
            if(exists) {
              postRef.on('value', this.gotData, this.errData)
            } else {
              console.log('沒有輸入')
            }
          })
        } else {
          window.location = ('/')
        }

      } else {
        window.location = ('/')
      }
    })
  }

  gotData(data) {
  let newProducts = []
  const userdata = data.val();
  const keys = Object.keys(userdata);
  for (let i = 0; i < keys.length; i++) {
    const k = keys[i];
    newProducts.push({
      name: userdata[k].name,
      title: userdata[k].title,
      createDate: userdata[k].createDate,
      createTime: userdata[k].createTime,
      value: userdata[k].value,
      mail: userdata[k].mail,
      id: userdata[k].id,
      repeat: userdata[k].repeat
    });
  }
  this.setState({blog: newProducts});
  }

  errData(err) {
   console.log(err);
  }

  buttonFormatter(id, post) {
    const location = {
      pathname: `/Mails/${post.id}`,
      state: { fromDashboard: true }
    }
    return  <Link to={location}>查看信件</Link>
  }

  render() {
    return(
      <div>
        <MetaTags>
            <title>草學藥事 || MailBox</title>
            <meta id="og-title" property="og:title" content="MailBox" />
        </MetaTags>
       <h1>管理信件</h1>
       <BootstrapTable
        ref='table'
        data={ this.state.blog }
        bodyContainerClass='table-responsive'
        pagination={ true }
        search={ true }
        >
        <TableHeaderColumn dataField='title' isKey={true} dataSort={ true }>主旨</TableHeaderColumn>
        <TableHeaderColumn dataField='name' dataSort={ true }>寄件人</TableHeaderColumn>
        <TableHeaderColumn dataField='createDate' dataSort={ true }>日期</TableHeaderColumn>
        <TableHeaderColumn dataField='createTime' dataSort={ true }>時間</TableHeaderColumn >
        <TableHeaderColumn dataSort={ true } dataFormat={this.buttonFormatter}>信件內容</TableHeaderColumn>
        <TableHeaderColumn dataField='repeat' dataSort={ true }>狀態</TableHeaderColumn >        
       </BootstrapTable>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/post/MailBox.js